// AUTO-GENERATED by scripts/build-migrations-manifest.js — do not edit.
// Regenerate with: node scripts/build-migrations-manifest.js
//
// Canonical list of migration filenames (without .sql) expected to be
// applied in the database. The SuperAdmin → Health page diffs this
// against public._schema_migrations rows (RPC: list_applied_migrations)
// to surface any unapplied migrations.

/* eslint-disable */
const MIGRATIONS_MANIFEST = [
  "001_initial_schema",
  "001a_fix_current_firm_id",
  "002_rls_perf",
  "003_fix_rls_recursion",
  "004_invite_code",
  "005_fix_join_firm_email",
  "006_documents",
  "007_employees",
  "008_conflict_checks",
  "009_deadlines_priority",
  "010_matter_status",
  "011_client_portal",
  "012_super_admin",
  "013_super_admin_firm_data",
  "014_firm_onboarding",
  "015_trial_system",
  "016_matter_notes",
  "017_auth_user_trigger",
  "018_firm_billing_settings",
  "019_matter_users",
  "020_user_trigger_firm_id",
  "021_firms_update_policy",
  "022_user_invite_status",
  "023_users_firm_read_policy",
  "024_public_intake_rls",
  "025_case_billing",
  "026_document_enhancements",
  "027_folder_nesting",
  "028_document_pinning",
  "029_payment_methods",
  "030_paystack_subscriptions",
  "031_rbac",
  "032_employee_auth",
  "033_subscription_plans",
  "034_partner_settings_edit",
  "035_employee_id_on_employees",
  "036_activity_view_permission",
  "037_deadlines_notes",
  "038_deadlines_trigger_date",
  "039_ghana_card_fields",
  "040_employee_profile_fields",
  "041_perf_indexes",
  "042_fix_current_firm_id",
  "043_case_charge_status",
  "044_invoice_share_token",
  "045_payment_receipt_number",
  "046_portal_invite_token",
  "047_portal_contact_for_user",
  "048_firm_team_chat",
  "049_firm_messages_sender_fk",
  "050_firm_messages_edit",
  "051_private_channels_and_dms",
  "052_create_private_channel_rpc",
  "053_fix_private_channel_rpc",
  "054_fix_private_channel_rpc_cast",
  "055_add_channel_member_rpc",
  "056_portal_thread_participants",
  "057_portal_messages_mark_read",
  "058_firm_channel_unread",
  "059_enable_realtime_messaging",
  "060_matter_access_control",
  "061_event_creator_ownership",
  "062_event_admin_override",
  "063_fk_on_delete_set_null",
  "064_matter_close_archive",
  "065_firm_matter_retention",
  "066_document_classification",
  "067_document_versions_and_audit",
  "068_document_classification_rls",
  "069_contacts_write_policy",
  "069b_contacts_create_permission",
  "070_portal_client_trigger_fix",
  "071_firm_creator_admin",
  "072_new_account_defaults",
  "073_portal_payments_rls",
  "074_repair_broken_accounts",
  "075_fix_firm_channels_rls",
  "076_force_account_repair",
  "077_get_my_firm_rpc",
  "078_restore_all_rls_policies",
  "079_fix_matters_rls_recursion",
  "080_complete_rls_all_tables",
  "081_employees_corporate_columns",
  "082_fix_firm_update_policy",
  "083_cleanup_misrouted_portal_clients",
  "084_portal_firm_branding_and_invoice_logo",
  "085_firm_name_snapshot_and_audit",
  "086_security_hardening",
  "087_portal_email_match_lockdown",
  "088_tighten_portal_cleanup",
  "089_secure_public_views",
  "090_lockdown_users_with_firm",
  "091_super_admin_rpc_guards",
  "092_server_side_impersonation",
  "093_access_log",
  "094_edge_function_rate_limit",
  "095_super_admin_management",
  "096_announcements_mrr_notifications",
  "097_announcement_dismiss_mode",
  "098_messaging_enhancements",
  "099_portal_thread_privacy",
  "100_messaging_overview",
  "101_message_search",
  "102_messaging_threads_pins_matter",
  "103_fix_invited_user_visibility",
  "104_scheduled_send_bookmarks_export",
  "105_message_retention",
  "106_message_tamper_seal",
  "107_push_subscriptions",
  "108_message_dlp",
  "109_messaging_seal_anchors",
  "110_thread_participant_rpcs",
  "111_e2e_encryption",
  "112_portal_document_workflow",
  "113_finance_view_firm_permission",
  "114_create_firm_rpc",
  "115_complete_firm_setup_rpc",
  "116_add_activity_log_details",
  "117_sample_data",
  "118_practice_area_starter_pack",
  "119_subscription_plan_enterprise",
  "120_add_staff_record_rpc",
  "121_refresh_schema_cache",
  "122_ensure_firm_channels_columns",
  "123_send_portal_message_rpc",
  "124_list_firm_channels_rpc",
  "125_messaging_rpcs",
  "126_user_onboarding_flags",
  "127_ensure_my_employee_record",
  "128_get_employee_for_firm_rpc",
  "129_fix_update_my_employee_profile",
  "130_firm_onboarding_idempotent",
  "131_firm_link_diagnostics",
  "132_firm_suspend_and_soft_delete",
  "133_firm_self_close",
  "134_financial_idempotency",
  "135_fix_empty_date_cast",
  "136_document_folder_rpcs",
  "137_firm_channel_create_rpc",
  "138_list_firm_users_rpc",
  "139_portal_thread_privacy_in_rpcs",
  "140_matter_confidential_flag",
  "141_firm_seat_enforcement",
  "142_super_admin_seat_visibility",
  "143_firm_storage_enforcement",
  "144_block_privilege_escalation",
  "145_paystack_webhook_idempotency",
  "146_fix_firm_message_mentions_cast",
  "147_fix_digest_search_path",
  "148_list_firm_users_drop_status",
  "149_demo_requests",
  "150_demo_request_notifications",
  "151_demo_view_tracking",
  "152_announcement_update_rpc",
  "153_deployment_health_check",
  "154_demo_requests_rls_repair",
  "155_block_firm_billing_writes",
  "156_paystack_webhook_health",
  "157_firms_billing_period",
  "158_fix_close_my_firm_billing_write",
  "159_demo_requests_security_definer_rpc",
  "160_enrich_firm_detail_stats",
  "161_health_check_supplementary",
  "162_schema_migrations_ledger",
  "163_fix_hc_body_contains_wildcard",
  "164_contacts_email_uniqueness",
  "165_preserve_time_entries_on_user_delete",
  "166_update_demo_notification_email_domain",
  "167_pg_cron_drain_notifications_outbox"
];

module.exports        = MIGRATIONS_MANIFEST;
module.exports.default = MIGRATIONS_MANIFEST;
